export default __webpack_public_path__ + "static/media/tuto-step-6.1f815ba9.gif";